import React, { useEffect, useState } from 'react'
import {
  ChevronLeft,
  ChevronRight
} from '@mui/icons-material'

import './styles/story.css'

const Carousel = (props) => {

  const {
    children,
    show
  } = props

  const [currentIndex, setCurrentIndex] = useState(0)
  const [length, setLength] = useState(children.length)

  const [visibleSlides, setVisibleSlides] = useState(
    window.innerWidth <= 768 ? 1 : show
  )

  const [touchPosition, setTouchPosition] = useState(null)

  /*
   * Keep the number of visible slides responsive
   */
  useEffect(() => {

    const handleResize = () => {

      setVisibleSlides(
        window.innerWidth <= 768 ? 1 : show
      )

    }

    window.addEventListener('resize', handleResize)

    return () => {
      window.removeEventListener('resize', handleResize)
    }

  }, [show])


  /*
   * Update number of children
   */
  useEffect(() => {

    setLength(children.length)

  }, [children])


  /*
   * Make sure current slide is still valid
   * when switching between desktop/mobile.
   */
  useEffect(() => {

    const maxIndex = Math.max(
      0,
      length - visibleSlides
    )

    if (currentIndex > maxIndex) {
      setCurrentIndex(maxIndex)

      if (props.onSlideChange) {
        props.onSlideChange(maxIndex)
      }
    }

  }, [
    visibleSlides,
    length,
    currentIndex,
    props
  ])


  /*
   * NEXT
   */
  const next = () => {

    if (currentIndex < (length - visibleSlides)) {

      const newIndex = currentIndex + 1

      setCurrentIndex(newIndex)

      if (props.onSlideChange) {
        props.onSlideChange(newIndex)
      }

      props.checkSlide(newIndex)

    }

  }


  /*
   * PREVIOUS
   */
  const prev = () => {

    if (currentIndex > 0) {

      const newIndex = currentIndex - 1

      setCurrentIndex(newIndex)

      if (props.onSlideChange) {
        props.onSlideChange(newIndex)
      }

    }

  }


  /*
   * TOUCH START
   */
  const handleTouchStart = (e) => {

    const touchDown = e.touches[0].clientX

    setTouchPosition(touchDown)

  }


  /*
   * TOUCH MOVE
   */
  const handleTouchMove = (e) => {

    const touchDown = touchPosition

    if (touchDown === null) {
      return
    }

    const currentTouch = e.touches[0].clientX

    const diff = touchDown - currentTouch

    if (diff > 5) {
      next()
    }

    if (diff < -5) {
      prev()
    }

    setTouchPosition(null)

  }


  return (

    <div className="carousel-container">

      <div className="carousel-wrapper">

        {/* LEFT ARROW */}

        {currentIndex > 0 && (

          <button
            className="left-arrow"
            onClick={prev}
            aria-label="Previous slide"
          >

            <ChevronLeft />

          </button>

        )}


        {/* CONTENT */}

        <div
          className="carousel-content-wrapper"
          onTouchStart={handleTouchStart}
          onTouchMove={handleTouchMove}
        >

          <div
            className={`carousel-content show-${visibleSlides}`}
            style={{
              transform: `translateX(-${
                currentIndex * (100 / visibleSlides)
              }%)`
            }}
          >

            {children}

          </div>

        </div>


        {/* RIGHT ARROW */}

        {currentIndex < (length - visibleSlides) && (

          <button
            className="right-arrow"
            onClick={next}
            aria-label="Next slide"
          >

            <ChevronRight />

          </button>

        )}

      </div>

    </div>

  )

}

export default Carousel